module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Savage-Kingdom-S3.6d7048e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Savage-Kingdom-S3.jpg
// module id = LQIK
// module chunks = 0